import axios from "axios";
const API = axios.create({
    baseURL: "https://erpapi.sapeagleerp.com/api",

});

export default API;